<template>
    <div class="report-container">
        <!-- <div class="bg-decoration ball-1"></div>
        <div class="bg-decoration ball-2"></div> -->
        
        <!-- <div class="overlay"></div> -->

        <div class="content-wrapper">
            <header class="header-section fade-in-down">
                <div class="greeting-box">
                    <p class="greeting-text">
                        Hi~ <span class="student-name">{{ ReportData.realname }}</span>
                    </p>
                    <!-- <div class="status-badge">学习旅伴已就绪</div> -->
                </div>
                <p class="sub-greeting">我们又见面啦</p>
            </header>

            <main class="message-card-wrapper fade-in-up">
                <div class="glass-card">
                    <div class="card-header">
                        <span class="date-tag">2026 · JAN</span>
                        <div class="line-decorator"></div>
                    </div>
                    
                    <div class="quote-group">
                        <p class="anim-line">我们知道，你正在完成很多事，</p>
                        <p class="anim-line">所以这份报告，</p>
                        <p class="anim-line">不急着回顾，也不急着要求。</p>
                        <div class="highlight-wrapper anim-line">
                            <p class="highlight-quote">它只是想告诉你：</p>
                            <div class="pulse-dot"></div>
                        </div>
                        <p class="anim-line emphasis">当工作告一段落，</p>
                        <p class="anim-line emphasis">学习，可以<span class="text-gradient">慢慢开始</span>。</p>
                    </div>
                </div>
            </main>

            <!-- <footer class="footer-hint fade-in">
                <p>一月的学习报告已为你生成</p>
                <div class="swipe-container">
                    <div class="mouse-icon">
                        <div class="wheel"></div>
                    </div>
                    <span class="swipe-text">左滑开启新篇章</span>
                </div>
            </footer> -->
			<footer class="footer-hint fade-in">
                <p>一月的学习报告已为你生成</p>
                <div class="swipe-guide">
                    <span class="arrow">‹</span>
                    <span>左滑查看更多内容</span>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    props: ["ReportData"]
}
</script>

<style scoped>
/* --- 基础样式与变量 --- */
:host {
    --primary-purple: #a855f7;
    --accent-gold: #fde047;
    --glass-bg: rgba(255, 255, 255, 0.1);
}

.report-container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: #0f172a; /* 深色底色防止切图加载时的白屏 */
    background: 
        url("../../assets/26January/logo.png") right  top  no-repeat,
        url("../../assets/26January/bg.jpg")  no-repeat;
	background-size: 100% 100%,cover;
	 width: 100%;
    height: 100vh;
    color: #666;
    font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
}

/* --- 装饰性元素 --- */
.bg-decoration {
    position: absolute;
    border-radius: 50%;
    filter: blur(60px);
    z-index: 0;
    opacity: 0.4;
    animation: float 8s infinite alternate ease-in-out;
}
/* .ball-1 { width: 300px; height: 300px; background: #6366f1; top: -50px; right: -50px; }
.ball-2 { width: 250px; height: 250px; background: #a855f7; bottom: 10%; left: -50px; animation-delay: -2s; } */

/* .overlay {
    position: absolute;
    inset: 0;
    background: radial-gradient(circle at center, transparent 0%, rgba(0,0,0,0.4) 100%);
    z-index: 1;
} */

.content-wrapper {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    padding: 7vh 8% 5vh;
    box-sizing: border-box;
}

/* --- 头部设计 --- */
.greeting-box {
    display: flex;
    align-items: baseline;
    gap: 12px;
}

.student-name {
	margin-top: 2vh;
    font-size: 32px;
    font-weight: 800;
    background: linear-gradient(to bottom, #e07171, #d03327);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: 0 4px 12px rgba(241, 101, 122, 0.3);
}

.status-badge {
    font-size: 11px;
    padding: 2px 8px;
    border: 1px solid rgba(255,255,255,0.3);
    border-radius: 12px;
    opacity: 0.8;
}

.sub-greeting {
    margin-top: 4px;
    letter-spacing: 4px;
    opacity: 0.6;
    font-weight: 800;
	color: #000;
}

/* --- 玻璃态卡片 --- */
.glass-card {
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 24px;
    padding: 12px 24px;
    box-shadow: 0 20px 50px rgba(0,0,0,0.3);
}

.anim-line{
    color: #000;
    font-weight: 400;
}

.date-tag {
    font-size: 18px;
    font-weight: 600;
    color: #d03327;
    letter-spacing: 2px;
}

.line-decorator {
    width: 30px;
    height: 3px;
    background: #da6868;
    margin: 12px 0 24px;
    border-radius: 2px;
}

.quote-group p {
    font-size: 17px;
    line-height: 2;
    margin-bottom: 6px;
    font-weight: 300;
}

.emphasis {
    font-size: 19px !important;
    font-weight: 500 !important;
}

.text-gradient {
    color: #d03327;
    font-weight: 700;
    padding: 0 4px;
}

.highlight-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 15px 0;
}

.highlight-quote {
    margin: 0 !important;
    color: #d03327;
    font-weight: 600 !important;
}

/* 呼吸小点 */
.pulse-dot {
    width: 6px;
    height: 6px;
    background: #d03327;
    border-radius: 50%;
    box-shadow: 0 0 10px #d03327;
    animation: pulse 2s infinite;
}

/* --- 底部引导 --- */
.swipe-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin-top: 15px;
}

.swipe-text {
    font-size: 13px;
    letter-spacing: 1px;
    opacity: 0.8;
    animation: bounceX 2s infinite;
}

/* --- 核心动画 --- */
@keyframes float {
    0% { transform: translate(0, 0) scale(1); }
    100% { transform: translate(20px, 30px) scale(1.1); }
}

@keyframes pulse {
    0% { transform: scale(1); opacity: 1; }
    50% { transform: scale(1.5); opacity: 0.5; }
    100% { transform: scale(1); opacity: 1; }
}

@keyframes fadeInUp {
    from { opacity: 0; transform: translateY(30px); }
    to { opacity: 1; transform: translateY(0); }
}

@keyframes bounceX {
    0%, 20%, 50%, 80%, 100% { transform: translateX(0); }
    40% { transform: translateX(-6px); }
    60% { transform: translateX(-3px); }
}

@keyframes moveLeft {
    0%, 100% { transform: translateX(0); opacity: 0.8; }
    50% { transform: translateX(-10px); opacity: 1; }
}

/* 逐行加载效果 */
.fade-in-up { animation: fadeInUp 1s ease-out both; }
.fade-in-down { transform: translateY(10px); }

.anim-line {
    opacity: 0;
    animation: fadeInUp 0.8s ease-out forwards;
}
.anim-line:nth-child(1) { animation-delay: 0.2s; }
.anim-line:nth-child(2) { animation-delay: 0.4s; }
.anim-line:nth-child(3) { animation-delay: 0.6s; }
.anim-line:nth-child(4) { animation-delay: 0.8s; }
.anim-line:nth-child(5) { animation-delay: 1.0s; }
.anim-line:nth-child(6) { animation-delay: 1.2s; }

/* 底部引导 */
.footer-hint {
    text-align: center;
}

.footer-hint p {
    font-size: 14px;
    opacity: 0.7;
    margin-bottom: 12px;
}

.swipe-guide {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 15px;
    animation: moveLeft 1.5s infinite ease-in-out;
}
/* PC端适配优化 */
@media screen and (min-width: 786px) {
	.report-container {
		background-image: url("../../assets/26January/pcbg.jpg");
	}

    .glass-card { max-width: 500px; margin: 0 auto; padding: 50px; }
    .student-name { font-size: 52px; }
    .content-wrapper { align-items: center; }


}
</style>